(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maya-founder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maya-founder-slider')) {
    class MayaFounderSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        if (this.slides.length < 2) return;
        this.interval = Number(this.dataset.interval) || 6000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i >= 0) this.go(i, true);
        });
        this.setupSwipe();
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.start();
          else this.stop();
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
      }

      start() {
        this.stop();
        if (this.reduced || !this.visible || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
      }

      go(target, manual) {
        const count = this.slides.length;
        this.index = ((target % count) + count) % count;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
        if (manual) this.start();
      }

      setupSwipe() {
        let startX = 0;
        this.addEventListener('touchstart', (event) => {
          startX = event.touches[0].clientX;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          const dx = event.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1), true);
        }, { passive: true });
      }
    }
    customElements.define('maya-founder-slider', MayaFounderSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maya-fragrances"] && !Shopify.designMode) return;
  try {
    
  class MayaFragrances extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-maya-filter]'));
      this.items = Array.from(this.querySelectorAll('.maya-fragrances__item'));
      this.chips.forEach((chip) => chip.addEventListener('click', () => this.filter(chip)));
    }

    filter(active) {
      const value = active.dataset.mayaFilter;
      this.chips.forEach((chip) => {
        const on = chip === active;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', String(on));
      });
      this.items.forEach((item) => {
        const card = item.querySelector('[data-maya-tag]');
        const match = !value || (card && card.dataset.mayaTag === value);
        item.hidden = !match;
      });
    }
  }

  if (!customElements.get('maya-fragrances')) {
    customElements.define('maya-fragrances', MayaFragrances);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maya-hero"] && !Shopify.designMode) return;
  try {
    
  class MayaHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-maya-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-maya-dot]'));
      this.index = 0;
      this.timer = null;
      this.initCountdowns();

      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.mayaDot));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.addEventListener('shopify:block:select', (event) => {
        const target = this.slides.indexOf(event.target);
        if (target < 0) return;
        this.stop();
        this.goTo(target);
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      clearInterval(this.clock);
    }

    initCountdowns() {
      this.countdowns = Array.from(this.querySelectorAll('[data-maya-countdown]'))
        .map((el) => ({ el, end: new Date(el.dataset.mayaCountdown.replace(' ', 'T')).getTime() }))
        .filter(({ end }) => !Number.isNaN(end));
      if (!this.countdowns.length) return;
      this.tick();
      this.clock = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const now = Date.now();
      this.countdowns.forEach(({ el, end }) => {
        const left = Math.max(0, Math.floor((end - now) / 1000));
        el.hidden = left === 0;
        const parts = {
          d: Math.floor(left / 86400),
          h: Math.floor((left % 86400) / 3600),
          m: Math.floor((left % 3600) / 60),
          s: left % 60,
        };
        Object.entries(parts).forEach(([unit, value]) => {
          const node = el.querySelector(`[data-unit="${unit}"]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
      });
    }

    goTo(target) {
      const count = this.slides.length;
      this.index = ((target % count) + count) % count;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('inert', !active);
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.timer) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const interval = Number(this.dataset.interval) * 1000 || 6000;
      this.timer = setInterval(() => this.goTo(this.index + 1), interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('maya-hero')) {
    customElements.define('maya-hero', MayaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maya-stories"] && !Shopify.designMode) return;
  try {
    
  class MayaStories extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.querySelectorAll('[data-story-sound]').forEach((button) => {
        button.addEventListener('click', () => this.toggleSound(button));
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.videos.forEach((video) => video.pause());
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.play().catch(() => {});
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: 0.35 }
      );
      this.videos.forEach((video) => this.observer.observe(video));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    toggleSound(button) {
      const video = button.parentElement.querySelector('video');
      if (!video) return;
      const unmute = video.muted;
      this.videos.forEach((other) => {
        other.muted = true;
        const otherButton = other.parentElement.querySelector('[data-story-sound]');
        if (otherButton) otherButton.setAttribute('aria-pressed', 'false');
      });
      video.muted = !unmute;
      if (unmute) video.play().catch(() => {});
      button.setAttribute('aria-pressed', String(unmute));
      button.setAttribute('aria-label', unmute ? this.dataset.offLabel || 'Desativar som' : this.dataset.onLabel || 'Ativar som');
    }
  }

  if (!customElements.get('maya-stories')) {
    customElements.define('maya-stories', MayaStories);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maya-video-carousel"] && !Shopify.designMode) return;
  try {
    
  class MayaCoverflow extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (!this.items.length) return;
      this.active = Math.floor((this.items.length - 1) / 2);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.items.forEach((item, i) => {
        item.addEventListener('click', (event) => {
          if (i !== this.active) {
            event.preventDefault();
            this.goTo(i);
          }
        });
        item.querySelector('[data-play]')?.addEventListener('click', (event) => {
          event.stopPropagation();
          if (i === this.active) this.play(item, true);
          else this.goTo(i);
        });
        item.querySelector('[data-sound]')?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggleSound(item);
        });
        const video = item.querySelector('video');
        if (video) {
          video.addEventListener('playing', () => {
            item.classList.add('is-playing');
            this.setLoading(item, false);
          });
          video.addEventListener('waiting', () => {
            if (!video.paused) this.setLoading(item, true);
          });
          video.addEventListener('stalled', () => {
            if (!video.paused) this.setLoading(item, true);
          });
          video.addEventListener('pause', () => {
            item.classList.remove('is-playing');
            this.setLoading(item, false);
          });
          video.addEventListener('ended', () => item.classList.remove('is-playing'));
          video.addEventListener('error', () => {
            item.classList.remove('is-playing');
            this.setLoading(item, false);
          });
        }
        video?.addEventListener('click', (event) => {
          if (i !== this.active) return;
          event.stopPropagation();
          const video = event.currentTarget;
          if (video.paused) this.play(item, true);
          else this.pause(item);
        });
      });
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot))));
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.goTo(this.active - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.active + 1));
      this.stage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.goTo(this.active + 1);
        if (event.key === 'ArrowLeft') this.goTo(this.active - 1);
      });
      this.setupSwipe();
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.items.indexOf(event.target);
        if (index >= 0) this.goTo(index);
      });

      this.visible = false;
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        const item = this.items[this.active];
        if (this.visible && this.dataset.autoplay === 'true') this.play(item, false);
        else this.pause(item);
      }, { threshold: 0.35 });
      this.observer.observe(this.stage);
      this.layout();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }

    offset(i) {
      const count = this.items.length;
      let d = i - this.active;
      if (d > count / 2) d -= count;
      if (d < -count / 2) d += count;
      return d;
    }

    layout() {
      const gap = parseFloat(getComputedStyle(this).getPropertyValue('--cf-gap')) || 0.62;
      this.items.forEach((item, i) => {
        const d = this.offset(i);
        const abs = Math.abs(d);
        const scale = Math.max(0.55, 1 - abs * 0.16);
        const shift = Math.sign(d) * (abs * gap - abs * (abs - 1) * 0.1) * 100;
        item.style.transform = `translateX(${shift}%) translateY(${abs * 6}%) scale(${scale})`;
        item.style.zIndex = String(20 - abs);
        item.style.opacity = abs > 3 ? '0' : '1';
        item.style.pointerEvents = abs > 3 ? 'none' : '';
        const active = d === 0;
        const video = item.querySelector('video');
        if (video && abs <= 1 && video.preload === 'none') video.preload = 'metadata';
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
        item.querySelectorAll('a, button').forEach((el) => {
          el.tabIndex = active ? 0 : -1;
        });
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.active));
    }

    goTo(target) {
      const count = this.items.length;
      const next = ((target % count) + count) % count;
      if (next === this.active) return;
      this.pause(this.items[this.active], true);
      this.active = next;
      this.layout();
      if (this.visible && this.dataset.autoplay === 'true') this.play(this.items[this.active], false);
    }

    play(item, userInitiated) {
      const video = item?.querySelector('video');
      if (!video) return;
      if (this.reduced && !userInitiated) return;
      video.preload = 'auto';
      if (video.readyState < 3) this.setLoading(item, true);
      const attempt = video.play();
      if (!attempt) return;
      attempt.catch((error) => {
        if (error.name === 'AbortError') {
          if (item.classList.contains('is-active')) {
            window.setTimeout(() => video.play().catch(() => {}), 150);
          }
          return;
        }
        if (error.name === 'NotAllowedError' && !video.muted) {
          video.muted = true;
          const sound = item.querySelector('[data-sound]');
          if (sound) sound.setAttribute('aria-pressed', 'false');
          video.play().catch(() => this.setLoading(item, false));
          return;
        }
        this.setLoading(item, false);
      });
    }

    setLoading(item, loading) {
      window.clearTimeout(item._mayaStall);
      item.classList.toggle('is-loading', loading);
      if (!loading) return;
      item._mayaStall = window.setTimeout(() => {
        const video = item.querySelector('video');
        if (!video || video.paused || !item.classList.contains('is-active')) return;
        if (video.readyState < 3) {
          const time = video.currentTime;
          video.load();
          video.currentTime = time;
          video.play().catch(() => this.setLoading(item, false));
        }
      }, 8000);
    }

    pause(item, reset) {
      const video = item?.querySelector('video');
      if (!video) return;
      if (!video.paused) video.pause();
      if (reset) {
        video.muted = true;
        const sound = item.querySelector('[data-sound]');
        if (sound) sound.setAttribute('aria-pressed', 'false');
      }
    }

    toggleSound(item) {
      const video = item.querySelector('video');
      const button = item.querySelector('[data-sound]');
      if (!video || !button) return;
      video.muted = !video.muted;
      button.setAttribute('aria-pressed', String(!video.muted));
      if (video.paused) this.play(item, true);
      else if (!video.muted) video.play().catch(() => {});
    }

    setupSwipe() {
      let startX = 0;
      let startY = 0;
      let tracking = false;
      this.stage.addEventListener('pointerdown', (event) => {
        tracking = true;
        startX = event.clientX;
        startY = event.clientY;
      });
      this.stage.addEventListener('pointerup', (event) => {
        if (!tracking) return;
        tracking = false;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          this.goTo(this.active + (dx < 0 ? 1 : -1));
        }
      });
      this.stage.addEventListener('pointercancel', () => {
        tracking = false;
      });
    }
  }

  if (!customElements.get('maya-coverflow')) {
    customElements.define('maya-coverflow', MayaCoverflow);
  }

  } catch(e) { console.error(e); }
})();
})();
